import Vue from 'vue'
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'aECOpClzm5H6sGXLeni3DXbGCdCgdiMM'
})
